import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.5 4.5v-3C4.5.675 5.175 0 6 0h7.5A1.5 1.5 0 0 1 15 1.5V9a1.5 1.5 0 0 1-1.5 1.5h-3v3A1.5 1.5 0 0 1 9 15H1.5A1.5 1.5 0 0 1 0 13.5V6c0-.825.675-1.5 1.5-1.5h3zm1.5 0h3A1.5 1.5 0 0 1 10.5 6v3h3V1.5H6v3zM1.5 6v7.5H9V6H1.5zm3 3V7.5H6V9h1.5v1.5H6V12H4.5v-1.5H3V9h1.5z",
  fill: "#000",
  "fill-rule": "nonzero"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}